import { useState, useEffect, ChangeEvent } from "react";
import {
  Form,
  Input,
  InputNumber,
  Select,
  DatePicker,
  Space,
  Checkbox,
  Modal,
} from "antd";
import Bin from "../../assets/bin.png";
import "./AddNewAccommodation.scss";
import NewParticipant from "../NewParticipant/NewParticipant";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import {
  AccommodationDto,
  AccommodationListDto,
  AdditionalPersonDto,
} from "../../models/Accommodation";
import { EventXRoomTypeCreate } from "../../models/EventXRoomTypeDto";
import { RoomTypeListDto } from "../../models/RoomType";
import { deleteRegistration } from "../../services/RegistrationService";
import { AxiosResponse } from "axios";
import dayjs from "dayjs";
import CustomButton from "../AccommodationData/CustomButton/CustomButton";

const AddNewAccommodation = (props: any) => {
  const { RangePicker } = DatePicker;
  let values = props.form.getFieldValue("accommodations");

  const watchRoomtype = values[props.name]?.roomType;

  const [numberOfNights, setNumberOfNights] = useState<any>(
    values[props.name]?.numberOfDays
  );
  const [allAccommodationOption, setAllAccommodationOption] = useState<
    AccommodationListDto[]
  >([]);
  const [roomTypesOptions, setRoomTypesOptions] = useState<RoomTypeListDto[]>(
    []
  );
  const [numberOfPersons, setNumberOfPersons] = useState([]);
  const [dateStart, setDateStart] = useState<string>();
  const [dateEnd, setDateEnd] = useState<string>();
  const [id, setId] = useState<string>("");
  const [roomPriceForPerson, setRoomPriceForPerson] = useState<any>();
  // const [priceOfAccommodation, setPriceOfAccommodation] = useState<any>();
  // const [showPriceForPerson, setShowPriceForPerson] = useState(false);
  const [newData, setNewData] = useState(false);
  const [max, setMax] = useState<any>(0);
  const min: number = 1;
  const [participantsNumber, setParticipantsNumber] = useState<number>(
    values[props.name]?.additionalPerson?.length
  );
  const [newMaxCapacity, setNewMaxCapacity] = useState<any>("");
  const [disableNumberOfPerson, setDisableNumberOfPerson] = useState(false);

  const Option = Select.Option;
  const [openViewModal, setOpenViewModal] = useState<boolean>(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [newPersonNumber, setNewPersonNumber] = useState<any>(0);
  const [roomCapacity, setRoomCapacity] = useState<any>();
  const uosPayment = values[props.name]?.uosPayment;
  const [notification, setNotification] = useState(false);
  const [disabledField, setDisabledField] = useState(false);

  const participantArray = Array.from(
    { length: participantsNumber ?? 0 },
    (_, index) => index
  ).map((el: any, index: number) => {
    if (values[props.name]?.additionalPerson?.length !== 0) {
      return values[props.name]?.additionalPerson?.find(
        (el1: AdditionalPersonDto, index1: number) => {
          if (index === index1) {
            return (el = el1);
          }
        }
      );
    } else {
      return;
    }
  });

  useEffect(() => {
    let totalPrice = 0;
    values.map((el: any) => {
      if (el?.priceOfAccommodation) {
        totalPrice = totalPrice + Number(el.priceOfAccommodation);
      }

      el?.additionalPerson?.map((el1: any) => {
        // if (!el1?.isAccommodationRequired) {
        //   console.log("el1", el1);
        //   totalPrice = totalPrice + props.registrationFee;
        // }
      });
    });

    props.handleTotalPrice(totalPrice);
    props.handleGetPriceData(false);
  }, [values, props.getNewPriceData]);

  useEffect(() => {
    let numberOfPersonsArray: any = [];
    for (let i = min; i <= max; i++) {
      numberOfPersonsArray.push({ label: i, value: i });
    }
    setNumberOfPersons(numberOfPersonsArray);
  }, [max]);

  useEffect(() => {
    let values = props.form.getFieldValue("accommodations");
    values = values.map((item: AccommodationDto, index: number) => {
      if (index === props.name) {
        return (item = {
          ...item,
          additionalPerson: participantArray,
          numberOfDays: numberOfNights,
          dateFrom: dateStart,
          // priceOfAccommodation: !showPriceForPerson
          //   ? numberOfNights === undefined
          //     ? priceOfAccommodation
          //     : Number(priceOfAccommodation) * numberOfNights
          //   : numberOfNights === undefined
          //   ? roomPriceForPerson[`priceFor${participantsNumber}Person`]
          //   : Number(
          //       roomPriceForPerson[`priceFor${participantsNumber}Person`]
          //     ) * numberOfNights,
          priceOfAccommodation:
            numberOfNights !== undefined &&
            participantsNumber !== undefined &&
            !uosPayment &&
            numberOfNights !== 0 &&
            roomPriceForPerson
              ? roomPriceForPerson[`priceFor${numberOfNights}Night`]
              : 0,
          dateTo: dateEnd,
          roomId: uuidv4(),
        });
      } else {
        return item;
      }
    });

    props.form.setFieldValue("accommodations", values);
  }, [numberOfNights, roomPriceForPerson, max, participantsNumber, uosPayment]);

  useEffect(() => {
    let fieldValue = props.form.getFieldValue("accommodations");

    fieldValue.filter((item: any, index: number) => {
      if (index === props.name) {
        const data = item?.additionalPerson?.map((el: any) => {
          return el?.status;
        });
        if (data.length < 2) {
          setDisabledField(false);
        } else {
          // if (
          //   data?.includes("Odobreno") ||
          //   data?.includes("Rezervisano") ||
          //   data?.includes("Odbijeno") ||
          //   data?.includes("Uplaćeno")
          // ) {
          //   setDisabledField(true);
          // }
        }
      }
    });
  }, []);

  useEffect(() => {
    if (props?.oneEvent === undefined) return;
    if (Object.keys(props?.oneEvent).length === 0) return;

    // let roomPrice = 0;

    // if (props.paramsId !== undefined) {
    //   props.oneEvent?.roomTypesForEvent.find((el: any) => {
    //     if (el.id === values[props.name]?.roomType) {
    //       if (el.priceForPerson) {
    //         setShowPriceForPerson(el.priceForPerson);
    //         const price = el.price;
    //         delete price.priceForRoom;
    //         setRoomPriceForPerson(price);
    //       } else {
    //         setShowPriceForPerson(false);
    //         roomPrice = el.price.priceForRoom;
    //       }
    //     }
    //   });

    //   setPriceOfAccommodation(roomPrice);
    // }

    props.oneEvent?.roomTypesForEvent.find((el: any) => {
      if (el.id === values[props.name]?.roomType) {
        if (el.priceForNight) {
          setRoomPriceForPerson(el.priceForNight);
        }
      }
    });

    props.oneEvent?.accommodations?.map((el: AccommodationDto) => {
      if (values[props.name]?.roomType) {
        el.roomTypes.find((elRoom: EventXRoomTypeCreate) => {
          if (elRoom.id === values[props.name]?.roomType) {
            setRoomCapacity(elRoom.roomType.capacity);
            setMax(elRoom.roomType.capacity);
            setNewMaxCapacity(elRoom.roomType.capacity);
          }
        });
      }

      if (el.id === values[props.name]?.accommodationId) {
        setId(el.id);
        props.form.setFieldValue("accommodations", values);
        if (props.individual) {
          props.handleGetData(true);
        }

        setNewData(true);
      }
    });
    const mapOptions = props.oneEvent.accommodations.map(
      (el: AccommodationDto) => {
        return { label: el.name, value: el.name, id: el.id };
      }
    );
    setAllAccommodationOption(mapOptions);
  }, [props.oneEvent]);

  useEffect(() => {
    if (!newData) return;
    props.oneEvent?.accommodations?.map((el: AccommodationDto) => {
      if (el.id === id) {
        const data: any = el.roomTypes.map((el: EventXRoomTypeCreate) => {
          return { label: el.name, value: el.name, id: el.id };
        });
        setRoomTypesOptions(data);
        setNewData(false);
        props.handleSpinner(false);
      }
    });
  }, [newData]);

  const handleDropdown = (e: string) => {
    let fieldValue = props.form.getFieldValue("accommodations");

    fieldValue = fieldValue.map((item: AccommodationDto, index: number) => {
      if (index === props.name) {
        return (item = {
          ...item,
          roomType: undefined,
          parkingPlaces: undefined,
          priceOfAccommodation: undefined,
          note: undefined,
        });
      } else {
        return item;
      }
    });

    props.form.setFieldValue("accommodations", fieldValue);
    setId(e);
    setNewData(true);
  };

  const handleOnClickRoomType = () => {
    let fieldValue = props.form.getFieldValue("accommodations");

    return fieldValue.filter((item: any, index: number) => {
      if (index === props.name) {
        const data = item?.additionalPerson?.map((el: any) => {
          if (el?.status) {
            return el?.status;
          } else {
            return;
          }
        });

        if (data?.length < 2) {
          setNotification(false);
          setDisabledField(false);
        } else {
          if (
            data.includes("Odobreno") ||
            data.includes("Rezervisano") ||
            data.includes("Odbijeno") ||
            data.includes("Uplaćeno")
          ) {
            setNotification(true);
            setDisabledField(true);
          }
        }
      }
    });
  };

  const handleRoomType = (roomTypeId: string) => {
    let fieldValue = props.form.getFieldValue("accommodations");

    let singleRoomType: EventXRoomTypeCreate | any = undefined;

    let maxCapacity: any = 0;

    // let roomPrice: any =
    //   roomPriceForPerson[`priceFor${participantsNumber}Person`];

    props.oneEvent?.accommodations?.find((el: AccommodationDto) => {
      if (el.id === id) {
        el.roomTypes.find((elRoom: EventXRoomTypeCreate) => {
          if (elRoom.id === roomTypeId) {
            setRoomCapacity(elRoom.roomType.capacity);
            maxCapacity = elRoom.roomType.capacity;
            setMax(elRoom.roomType.capacity);
            return (singleRoomType = elRoom);
          }
        });
      }
    });

    if (fieldValue[props.name].numberOfPersons > maxCapacity) {
      setOpenAlertModal(true);

      fieldValue = fieldValue.map((item: AccommodationDto, index: number) => {
        if (index === props.name) {
          return (item = {
            ...item,
            roomType: "",
          });
        } else {
          return item;
        }
      });
      setMax(newMaxCapacity);
      setDisableNumberOfPerson(true);

      return props.form.setFieldValue("accommodations", fieldValue);
    }

    setNewMaxCapacity(maxCapacity);
    setDisableNumberOfPerson(false);

    setRoomPriceForPerson(props?.oneEvent?.priceForNight);

    props.oneEvent?.roomTypesForEvent.find((el: any) => {
      if (el.id === roomTypeId) {
        if (el.priceForNight) {
          setRoomPriceForPerson(el.priceForNight);
        }
      }
    });

    // props.oneEvent?.roomTypesForEvent.find((el: any) => {
    //   if (el.id === roomTypeId) {
    //     if (el.priceForPerson) {
    //       setShowPriceForPerson(el.priceForPerson);
    //       const price = el.price;
    //       delete price.priceForRoom;
    //       setRoomPriceForPerson(price);
    //     } else {
    //       setShowPriceForPerson(false);
    //       roomPrice = el.price.priceForRoom;
    //     }
    //   }
    // });

    // setPriceOfAccommodation(roomPrice);

    fieldValue = fieldValue.map((item: AccommodationDto, index: number) => {
      if (index === props.name) {
        return (item = {
          ...item,
          note: singleRoomType?.note,
          parkingPlaces: singleRoomType?.parkingPlace,
          // priceOfAccommodation: roomPrice,
        });
      } else {
        return item;
      }
    });

    props.form.setFieldValue("accommodations", fieldValue);

    if (props.individual) {
      if (props.paramsId === undefined) {
        if (participantsNumber === undefined || participantsNumber === 0) {
          setParticipantsNumber(1);
        } else {
          return;
        }
      } else {
        setParticipantsNumber(values[0]?.additionalPerson?.length);
      }
      props.handleGetData(true);
    }
  };

  const handleNewParticipantNumber = (numberOfPersons: number) => {
    setParticipantsNumber(numberOfPersons);
    const newValues = values.map((item: AccommodationDto, index: number) => {
      if (index === props.name) {
        return (item = {
          ...item,
          numberOfPersons: numberOfPersons,
        });
      } else {
        return item;
      }
    });

    props.form.setFieldValue("accommodations", newValues);

    const value = Math.max(min, Math.min(max, Number(numberOfPersons)));
    if (props.paramsId) {
      if (Number(numberOfPersons) > participantArray.length) {
        return setParticipantsNumber(value);
      } else {
        const data = participantArray.slice(Number(numberOfPersons));
        data.find((el: any) => {
          if (el && el.id) {
            deleteRegistration(el.id)
              .then((response: AxiosResponse) => {
                setParticipantsNumber(value);
              })
              .catch((err: Error) => console.log(err));
          } else {
            setParticipantsNumber(value);
          }
        });
      }
    }
  };

  const handleDeleteAccommdoation = () => {
    let values = props.form.getFieldValue("accommodations");

    if (!values) return;
    if (props.paramsId) {
      values = values.map((item: any, index: number) => {
        if (index === props.name) {
          item.additionalPerson.map((el: any) => {
            deleteRegistration(el.id)
              .then((response: any) => {})
              .catch((err: Error) => console.log(err));
          });
        }
      });
    }
  };

  const handleDisabledDates = (current: any) => {
    if (props.oneEvent?.date) {
      const from = props.oneEvent.date[0].$d;
      const to = props.oneEvent.date[1].$d;

      const newDateFrom = moment(from, "DD-MM-YYYY");
      const newDateTo = moment(to, "DD-MM-YYYY").add(1, "days");
      return newDateFrom > current.$d || newDateTo <= current.$d;
    } else {
      return true;
    }
  };

  const handleTotalParticipants = (e: ChangeEvent<HTMLInputElement>) => {
    if (Number(e) < participantsNumber) {
      setNewPersonNumber(e);
      return setOpenViewModal(true);
    }
    const value = Math.max(min, Math.min(max, Number(e)));
    return setParticipantsNumber(value);
  };

  const handleRangePicker = (e: any) => {
    const startDate = e[0].$d;
    const endDate = e[1].$d;
    setDateStart(moment(startDate).format("DD/MM/YYYY"));
    setDateEnd(moment(endDate).format("DD/MM/YYYY"));

    const timeDifference = endDate.getTime() - startDate.getTime();

    const dayDifference = timeDifference / (1000 * 3600 * 24);

    setNumberOfNights(Number(dayDifference.toFixed(0)));
  };

  return (
    <div className="add-new-accommodation">
      <div className="inner-container">
        <div className="header-accommodation">
          <p className="accommodation-number">{`Soba - ${props.name + 1}`}</p>
        </div>
        <Form.Item
          className="selection"
          name={[props.name, "accommodationId"]}
          label="Smeštaj:"
          rules={
            props.needAccommodation
              ? [
                  {
                    required: true,
                    message: "Potrebno je uneti smeštaj!",
                  },
                ]
              : []
          }
        >
          <Select onChange={handleDropdown} placeholder="Izaberite smeštaj">
            {allAccommodationOption.map(
              (el: AccommodationListDto, i: number) => (
                <Option key={el.id} value={el.id}>
                  {el.value}
                </Option>
              )
            )}
          </Select>
        </Form.Item>
        <Form.Item
          className="inner-selection"
          name={[props.name, "roomType"]}
          label="Tip sobe:"
          rules={
            props.needAccommodation
              ? [
                  {
                    required: true,
                    message: "Potrebno je uneti tip sobe!",
                  },
                ]
              : []
          }
        >
          <Select
            onClick={handleOnClickRoomType}
            onChange={handleRoomType}
            placeholder="Tip sobe"
            disabled={disabledField}
          >
            {roomTypesOptions.map((el: RoomTypeListDto, i: number) => (
              <Option key={el.id} value={el.id}>
                {el.value}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name={[props.name, "date"]}
          label="Odabrani datumi:"
          rules={
            props.needAccommodation
              ? [
                  {
                    required: true,
                    message: "Potrebno je uneti datum!",
                  },
                  {
                    validateTrigger: "onSubmit",
                    validator: async (_, value) => {
                      if (numberOfNights < 1) {
                        return Promise.reject(
                          new Error(`Minimalan broj dana je 1!`)
                        );
                      } else {
                        return Promise.resolve();
                      }
                    },
                  },
                ]
              : []
          }
        >
          <RangePicker
            disabledDate={handleDisabledDates}
            onChange={handleRangePicker}
            defaultPickerValue={[
              dayjs(props.oneEvent?.date[0].$d),
              dayjs(props.oneEvent?.date[0].$d),
            ]}
            showTime={false}
            format="YYYY-MM-DD"
          />
        </Form.Item>
        <div className="field-box-first">
          <Form.Item
            {...props.restField}
            className="first-input"
            name={[props.name, "numberOfDays"]}
            label="Broj noćenja:"
          >
            <Input
              type="number"
              className="input-label"
              placeholder="Broj noćenja"
            />
          </Form.Item>
          <Form.Item
            {...props.restField}
            className={
              disableNumberOfPerson || watchRoomtype
                ? "second-input"
                : "second-input-disabled"
            }
            name={[props.name, "numberOfPersons"]}
            label="Broj osoba:"
            rules={[
              {
                validateTrigger: "onSubmit",
                validator: async (_, value) => {
                  if (roomCapacity !== value) {
                    return Promise.reject(
                      new Error(`Minimalan broj osoba ${roomCapacity}!`)
                    );
                  } else {
                    return Promise.resolve();
                  }
                },
              },
            ]}
          >
            <Select
              onClick={handleOnClickRoomType}
              onChange={handleTotalParticipants}
              placeholder="Broj osoba"
              disabled={disabledField}
            >
              {numberOfPersons.map((el: RoomTypeListDto, i: number) => (
                <Option key={el.value} value={el.value}>
                  {el.value}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <Form.Item
          {...props.restField}
          name={[props.name, "priceOfAccommodation"]}
          className="disabled-field"
          label="Ukupna cena smeštaja:"
        >
          <InputNumber
            style={{ width: "100%" }}
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value!.replace(/\$\s?|(,*)/g, "")}
          />
        </Form.Item>
        <div className="field-box-parking-payment">
          {values[props.name]?.parkingPlaces && (
            <Form.Item
              {...props.restField}
              name={[props.name, "parkingPlaces"]}
              className="disabled-field"
              valuePropName="checked"
            >
              <Checkbox className="input-label" type="checkbox">
                <p className="checkbox-text">Obezbeđeno parking mesto</p>
              </Checkbox>
            </Form.Item>
          )}
          <Form.Item
            className="uos-payment"
            name={[props.name, "uosPayment"]}
            valuePropName="checked"
          >
            <Checkbox
              onChange={() => props.handleGetPriceData(true)}
              className="checkbox"
            >
              <p className="checkbox-text">UOS plaća</p>
            </Checkbox>
          </Form.Item>
          {props.individual && props.paramsId ? null : (
            <div className="btn-container">
              <div
                className="btn"
                onClick={() => {
                  handleDeleteAccommdoation();
                  props.remove(props.name);
                  props.handleGetPriceData(true);
                }}
              >
                <img alt="" src={Bin} />
              </div>
            </div>
          )}
        </div>
        {/* <div className="field-box-second">
          <Form.Item
            {...props.restField}
            className="form-input-first"
            name={[props.name, "note"]}
            label="Dodatna napomena:"
          >
            <Input className="input-label" addonAfter={<EditOutlined />} />
          </Form.Item>
        </div> */}
        <div className="participants-list">
          <Form.List name={[props.name, "additionalPerson"]}>
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space key={key} className="list-of-data" align="baseline">
                    <NewParticipant
                      form={props.form}
                      accommodation={true}
                      accommodationName={props.name}
                      name={name}
                      paramsId={props.paramsId}
                      restField={{ ...restField }}
                      remove={remove}
                      handleGetPriceData={props.handleGetPriceData}
                      handleGetData={props.handleGetData}
                      compoanyRegistration={props.compoanyRegistration}
                      allImportedParticipants={props.allImportedParticipants}
                      importedParticipantOptions={
                        props.importedParticipantOptions
                      }
                      handleImportedParticipants={
                        props.handleImportedParticipants
                      }
                      individual={props.individual}
                    />
                  </Space>
                ))}
              </>
            )}
          </Form.List>
        </div>
      </div>
      <Modal
        maskClosable={false}
        open={openViewModal}
        title={`Potvrda brisanja`}
        onCancel={() => setOpenViewModal(false)}
        onOk={() => setOpenViewModal(false)}
        footer={[
          <CustomButton
            danger={false}
            htmlType={"submit"}
            key={1}
            type={"primary"}
            function={() => {
              handleNewParticipantNumber(newPersonNumber);
              setOpenViewModal(false);
            }}
            text={"Potvrdi"}
          />,
          <CustomButton
            danger={false}
            htmlType={"submit"}
            key={2}
            type={"primary"}
            function={() => {
              handleNewParticipantNumber(participantsNumber);
              setOpenViewModal(false);
            }}
            text={"Zatvori"}
          />,
        ]}
      >
        <p className="notification-content">{`Da li ste sigurni da zelite da nastavite?`}</p>
      </Modal>
      <Modal
        maskClosable={false}
        open={openAlertModal}
        title={`Obavestenje`}
        onCancel={() => setOpenAlertModal(false)}
        onOk={() => setOpenAlertModal(false)}
        footer={[
          <CustomButton
            danger={false}
            htmlType={"submit"}
            type={"primary"}
            key={1}
            function={() => setOpenAlertModal(false)}
            text={"Zatvori"}
          />,
        ]}
      >
        <p className="notification-content">{`Izabrali ste sobu sa kapacitetom koji je manji od unetog broja osoba u jednoj sobi. Smanjite broj osoba u jednoj sobi ili izaberite drugu sobu!`}</p>
      </Modal>
      <Modal
        maskClosable={false}
        open={notification}
        title={`Obavestenje`}
        onCancel={() => setNotification(false)}
        onOk={() => setNotification(false)}
        footer={[
          <CustomButton
            danger={false}
            htmlType={"submit"}
            type={"primary"}
            key={1}
            function={() => setNotification(false)}
            text={"Zatvori"}
          />,
        ]}
      >
        <p className="notification-content">{`Nije moguce promeniti tip sobe iz dvokrevetne u jednokrevetnu kada je prijava odobrena. Ako idalje želite da promenite tipove sobe morate da otkažete (izbrišete) prijave pa ponovo da ih kreirate!`}</p>
      </Modal>
    </div>
  );
};

export default AddNewAccommodation;
